import { render, staticRenderFns } from "./LayoutAuthCenter.vue?vue&type=template&id=2cd60c2c&"
import script from "./LayoutAuthCenter.vue?vue&type=script&lang=ts&"
export * from "./LayoutAuthCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports